export enum RequestLinkDirection {
	LinkedTo = "LINKED_TO",
	LinkedFrom = "LINKED_FROM",
}
